import React from 'react';
import type { IconProps } from '../../types';

interface CloseIconProps extends IconProps {
  className?: string;
  strokeWidth?: number;
}

export const CloseIcon: React.FC<CloseIconProps> = ({
  className = 'w-5 h-5',
  strokeWidth = 1,
  ...props
}) => {
  return (
    <svg
      className={className}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  );
};
